import React from 'react';

/**
 * Grey shimmering placeholder for a widget's first load. Widgets lay these out
 * in the shape of their finished content, so the dashboard keeps its height
 * instead of snapping open when data arrives.
 */
export default function Skeleton({
  width = '100%',
  height = 12,
  radius,
  style,
}: {
  width?: number | string;
  height?: number;
  radius?: number;
  style?: React.CSSProperties;
}) {
  return (
    <span
      className="skeleton"
      aria-hidden="true"
      style={{ width, height, ...(radius !== undefined ? { borderRadius: radius } : {}), ...style }}
    />
  );
}
